import React, { useEffect, useState } from "react";
import DefaultHeader from "../../../../shared/DefaultHeader.js";
import headerBg from "../../../../assets/image/headerBgJob.jpg";
import { jobUserList } from "../../../../services/postService.js";
import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import JobFilterBar from "../../../../components/user/Jobs/JobFilterBar.js";
import JobCard from "../../../../components/user/Jobs/JobCard.js";

const JobsList = () => {
  const [activeTab, setActiveTab] = useState("");
  const [keyword, setKeyword] = useState("");
  const [search, setSearch] = useState("");
  const [department, setDepartment] = useState("");
  const [experience, setExperience] = useState("");
  const [filters, setFilters] = useState({
    limit: 5,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [searchPayload, setSearchPayload] = useState({
    keyword: "",
    department: "",
    experience: "",
  });

  useEffect(() => {
    console.log("active....", activeTab);
  }, [activeTab]);

  // const filteredJobs = data?.data?.filter((job) => job.categories.includes(activeTab));

  // API calling for job list
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["standard-job", filters, searchPayload, activeTab],
    queryFn: async () => {
      const res = await jobUserList({
        ...filters,
        // ...(search && { keyword: search }),
        type: "standard-job",
        jobType: activeTab,
        ...(searchPayload.keyword && { keyword: searchPayload.keyword }),
        ...(searchPayload.department && { department: searchPayload.department }),
        ...(searchPayload.experience && { experience: searchPayload.experience }),
      });
      if (res?.status !== 200) {
        console.log(searchPayload);
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  return (
    <>
      <div className="mx-6 -my-14 py-12 px-4 sm:px-6 lg:px-8">
        <DefaultHeader />
        <div>
          <div className="relative bg-cover bg-center min-h-[400px]" style={{ backgroundImage: `url(${headerBg})` }}>
            <div className="absolute inset-0 bg-black/50" /> {/* Optional overlay */}
            <div className="relative mx-auto px-6 py-20">
              <div className="border-l-8 my-4 border-emerald-500 pl-6">
                <h1 className="text-7xl font-extrabold text-white animate-slide-in-down">Job Posts</h1>
                <div className="mt-4 text-lg text-white uppercase tracking-wide space-x-1 animate-slide-in-up">
                  <span className="text-emerald-400">Explore</span>
                  <span>{" > "}</span>
                  <span className="text-emerald-400">Discover</span>
                  <span>{" > "}</span>
                  <span className="text-white">Apply</span>
                </div>
              </div>
            </div>
          </div>
          <JobFilterBar
            keyword={keyword}
            setKeyword={setKeyword}
            setFilters={setFilters}
            setDepartment={setDepartment}
            setExperience={setExperience}
            setActiveTab={setActiveTab}
            onSearch={() => {
              setFilters((prev) => ({ ...prev, page: 1 }));
              setSearch(keyword);
              setSearchPayload({
                keyword,
                department,
                experience,
              });
            }}
          />

          <h1 className="text-3xl font-bold text-center text-gray-800 mb-11 animate-slide-in-up mt-[50px] uppercase">Find Your Fit</h1>
          {isFetching ? (
            <div className="flex justify-center min-h-screen bg-white">
              <div
                className="w-6 h-6 border-4 border-dashed rounded-full animate-spin 
        border-red-500 border-t-yellow-500 border-r-green-500 border-b-blue-500"
              ></div>
              <div classNames="mx-5">Loading</div>
            </div>
          ) : (
            ""
          )}

          {/* Tab Navigation */}
          {/* <div className="text-center mb-8 animate-slide-in-up cursor-pointer">
            <nav className="inline-flex border-b border-gray-200">
              <button
                onClick={() => setActiveTab("")}
                className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors duration-200 ${
                  activeTab === ""
                    ? "border-emeraldPrimary text-emeraldPrimary"
                    : "border-transparent text-gray-700 hover:text-gray-900 hover:border-gray-300"
                }`}
              >
                All
              </button>
              <button
                onClick={() => setActiveTab("full-time")}
                className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors duration-200 ${
                  activeTab === "full-time"
                    ? "border-emeraldPrimary text-emeraldPrimary"
                    : "border-transparent text-gray-700 hover:text-gray-900 hover:border-gray-300"
                }`}
              >
                Full Time
              </button>
              <button
                onClick={() => {
                  setActiveTab("part-time");
                  setFilters((prev) => ({ ...prev, page: 1 }));
                }}
                className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors duration-200 ${
                  activeTab === "part-time"
                    ? "border-emeraldPrimary text-emeraldPrimary"
                    : "border-transparent text-gray-700 hover:text-gray-900 hover:border-gray-300"
                }`}
              >
                Part Time
              </button>
              <button
                onClick={() => {
                  setActiveTab("internship");
                  setFilters((prev) => ({ ...prev, page: 1 }));
                }}
                className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors duration-200 ${
                  activeTab === "internship"
                    ? "border-emeraldPrimary text-emeraldPrimary"
                    : "border-transparent text-gray-700 hover:text-gray-900 hover:border-gray-300"
                }`}
              >
                Internship
              </button>
              <button
                onClick={() => {
                  setActiveTab("remote");
                  setFilters((prev) => ({ ...prev, page: 1 }));
                }}
                className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors duration-200 ${
                  activeTab === "remote"
                    ? "border-emeraldPrimary text-emeraldPrimary"
                    : "border-transparent text-gray-700 hover:text-gray-900 hover:border-gray-300"
                }`}
              >
                Remote
              </button>
            </nav>
          </div> */}

          {/* Job List */}
          <div className="space-y-4 animate-slide-in-up">
            {data?.data?.map((job) => (
              <JobCard key={job.id} job={job} />
            ))}
          </div>

          {/* Browse More */}
          <div className="text-center mt-8">
            <button
              className="px-8 py-4 bg-emeraldPrimary hover:bg-emeraldPrimary-700 text-white rounded-lg font-medium text-lg transition-colors duration-200"
              onClick={() => {
                setFilters((prev) => ({ ...prev, page: prev.page + 1 }));
              }}
            >
              See More Jobs
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobsList;
